import styled from 'styled-components';
import {dFlex, dFlexColumn, dFlexCenter, dFlexBetween, justifyBetween, alignCenter} from '../../../../../../globalVariables/GlobalFlex';
import {LIGHT_BLUE6, MANDATORY_BG, MANDATORY_TEXT, OPTIONAL_BG, OPTIONAL_TEXT, BLACK, TURQUISE_BLUE_50, TURQUISE_BLUE_70, LIGHT_BLUE_60, LIGHT_BLUE_80, mobileMedia, desktopMedia} from '../../../../../../globalVariables/GlobalVariables';
import {Close} from '../../../../../../component/close/Close.css';

export const header = styled.div`
    background: ${LIGHT_BLUE6};
    height: 140px;
    padding: 20px;
    ${dFlexColumn}
    ${justifyBetween}
    ${mobileMedia}{
        padding: 20px 10px;
    }
    ${Close}{
        position: absolute;
        ${desktopMedia}{
            background-size: 15px;
        } 
    }
`;

export const headerTop = styled.div`
    margin-bottom: 15px;
    margin-inline-start: 40px;
`;

export const subscriptionTitle = styled.h1`
    color: ${BLACK};
    font-size: 20px;
    font-weight: 600;
`;

export const subscriptionSubtitle = styled.p`
    color: ${BLACK};
    font-weight: 400;
`;

export const headerBottom = styled.div`
    ${dFlexBetween}
`;

export const summaryLabels = styled.div`
    ${dFlex}
    gap: 15px;
    ${mobileMedia}{
        height: 30px;
        gap: 4px;

    }
`;

export const summaryLabel = styled.div`
    ${dFlexCenter}
    gap: 4px;
    padding: 10px;
    min-width: 80px;
    font-size: 12px;
    border-radius: 38px;
    text-align: start;
    font-weight: 800;
    &.mandatory {
        background: ${MANDATORY_BG};
    }
    
    &.optional {
        background: ${OPTIONAL_BG};
    }
    &.all {
        background: ${LIGHT_BLUE6};
    }
`;

export const summaryText = styled.div`
    &.mandatory {
        color: ${MANDATORY_TEXT};
    }
    &.all {
        color: ${BLACK};
    }
    &.optional {
        color: ${OPTIONAL_TEXT};
    }
`;

export const createEventButton = styled.div`
    ${dFlex}
    ${alignCenter}
    button {
        border-radius: 200px;
        border: 2px solid ${TURQUISE_BLUE_50};
        background: ${LIGHT_BLUE_60};
        color: ${BLACK};
        text-align: center;
        font-weight: 800;
        padding: 8px 16px;
        transition: all 0.2s ease;
        &:hover {
            background: ${LIGHT_BLUE_80};
            border-color: ${TURQUISE_BLUE_70};
        }
    }
`;

export const plusIcon = styled.span`
    margin-inline-end: 5px;
    font-size: 16px;
`;
